import React, { PropsWithChildren } from "react";

import { Footer } from "components/Footer/Footer";

import { cn } from "@/common/utils/css.utils";
import { UsMarketBanner } from "@/features/us-market/components/UsMarketBanner";
import Header from "@whoppah/components/Header/Header";

type MainLayoutProps = {
  header?: React.ReactElement;
  headerClassName?: string;
  footer?: React.ReactElement;
  hideSearch?: boolean;
  hideFooter?: boolean;
  fullWidthContainer?: boolean;
};

const MainLayout = ({
  children,
  header = <Header />,
  headerClassName = undefined,
  footer = <Footer />,
  hideSearch = false,
  hideFooter = false,
  fullWidthContainer = false,
}: PropsWithChildren<MainLayoutProps>) => {
  return (
    <>
      <div className="flex min-h-screen flex-col">
        {React.cloneElement(header, {
          focused: hideSearch,
          className: cn(header.props.className, headerClassName),
        })}
        {/* WHO-6510: a US visitor on another language; renders nothing with the US launch off. */}
        <UsMarketBanner />
        <div
          className={cn(
            "relative flex w-full flex-1 flex-col",
            !fullWidthContainer && "mx-auto xl:container"
          )}
        >
          {children}
        </div>
      </div>
      {!hideFooter ? footer : null}
    </>
  );
};

export default MainLayout;
